/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pWalletMenu.vue?vue&type=template&id=3b9e1936&scoped=true"
import script from "./pWalletMenu.vue?vue&type=script&lang=js"
export * from "./pWalletMenu.vue?vue&type=script&lang=js"
import style0 from "./pWalletMenu.vue?vue&type=style&index=0&id=3b9e1936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9e1936",
  null
  
)

export default component.exports